// Backend contract types for the Customer aggregate (mirrors partners/interfaces/rest/dto/*).

export type CustomerType = 'PERSON' | 'COMPANY'

export type AddressKind = 'residence' | 'correspondence' | 'installation'

export interface PhoneDto {
  id: number | null
  value: string
  label: string | null
  isPrimary: boolean
  isActive: boolean
}

export interface EmailDto {
  id: number | null
  value: string
  label: string | null
  isPrimary: boolean
  isActive: boolean
}

export interface AddressDto {
  id: number | null
  kind: AddressKind
  street: string | null
  city: string | null
  postalCode: string | null
  countryCode: string
  isPrimary: boolean
  isActive: boolean
}

export interface Customer {
  id: number
  code: string | null
  type: CustomerType
  firstName: string | null
  lastName: string | null
  pesel: string | null
  name: string | null
  nip: string | null
  regon: string | null
  parentId: number | null
  typeProjectCode: string | null
  assigneeUserId: number | null
  voivodeshipCode: string | null
  note: string | null
  isActive: boolean
  phones: PhoneDto[]
  emails: EmailDto[]
  addresses: AddressDto[]
  createdAt: string
  updatedAt: string
  createdByUserId: number
  updatedByUserId: number
}

export interface CustomerListResponse {
  items: Customer[]
  total: number
  offset: number
  limit: number
}

export interface CreateCustomerRequest {
  type: CustomerType
  firstName?: string | null
  lastName?: string | null
  pesel?: string | null
  name?: string | null
  nip?: string | null
  regon?: string | null
  parentId?: number | null
  typeProjectCode?: string | null
  assigneeUserId?: number | null
  voivodeshipCode?: string | null
  note?: string | null
  phones?: PhoneDto[]
  emails?: EmailDto[]
  addresses?: AddressDto[]
}

export interface UpdateCustomerCoreRequest {
  type: CustomerType
  firstName?: string | null
  lastName?: string | null
  pesel?: string | null
  name?: string | null
  nip?: string | null
  regon?: string | null
  parentId?: number | null
  typeProjectCode?: string | null
  assigneeUserId?: number | null
  voivodeshipCode?: string | null
  note?: string | null
  isActive: boolean
}

export function customerDisplayName(c: Customer): string {
  if (c.type === 'COMPANY') return c.name ?? '(brak nazwy)'
  const parts = [c.firstName, c.lastName].filter(Boolean) as string[]
  return parts.length > 0 ? parts.join(' ') : '(brak imienia)'
}
